import React from 'react';
import injectSheet from 'react-jss';
import styleSheet from './styles';
import classNames from 'classnames';

interface PillListProps {
  classes: any;
  pills: any;
  label: string;
  activePills: {};
  onClick: (pill:any) => void;
}

const PillList = ({
  classes, pills, label, onClick, activePills
}: PillListProps) => {

  return(
    <div>
      <label className={classes.label}>
        {label}
      </label>
      <div className={classes.pillContainer}>
        {pills.map((item: any, index: number) => {
          return (
            <button 
              className={classNames(classes.pill, { [classes.activePill] : activePills[item.value]})}
              value={item.value}
              onClick={() => onClick(item.value)}
              key={index}
            >
              {item.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default injectSheet(styleSheet)(PillList);